import AuthTokenResourceModel from '../../generated/types/model/resource/AuthTokenResourceModel';

export default class AuthTokenResourceViewModel extends AuthTokenResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
